<template>
  <!-- && item.isShow === 1 && pcList && pcList.length > 0 -->
  <div v-if="item && list.length !== 0" class="mode4-box relative">
    <div class="relative mode4-header">
      <el-skeleton :loading="skeletonLoading" animated :throttle="0">
        <template slot="template">
          <el-skeleton-item variant="text" style="width: 150px; height: 24px; margin-left: -35px" />
        </template>
        <template>
          <div style="display: flex; align-items: center">
            <img
              class="title-icon"
              v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.icon"
              :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.icon)"
              alt
            />
            <span class="title"> {{ $utils.lang_data(lang, item.list[0] && item.list[0], "langInfoObj")?.title }}</span>
          </div>
        </template>
      </el-skeleton>
      <i
        v-if="showType === 1"
        @click="canPrev ? $refs.slideList.prev() : ''"
        :class="canPrev ? '' : 'disabled'"
        class="icon-arrow-common el-icon-arrow-left custom"
      ></i>

      <i
        v-if="showType === 1"
        :class="canNext ? '' : 'disabled'"
        @click="canNext ? $refs.slideList.next() : ''"
        class="icon-arrow-common el-icon-arrow-right custom"
      ></i>
    </div>
    <div class="hot-content" style="overflow: hidden">
      <!-- 显示4个 -->
      <GameSlide
        ref="slideList"
        class="slideList"
        v-if="showType === 1"
        :list="list"
        :show-count="colNum"
        :peek-width="2"
        :gap="2"
        :isLucky="true"
        @update:canPrev="onCanPrevChange"
        @update:canNext="onCanNextChange"
      >
        <template #default="{ item, index }">
          <div class="luckyMoudle">
            <el-row :gutter="30">
              <el-col :span="10">
                <gameItem @play="reportClick" :key="'game_' + item.gameName" :item="item" :skeletonLoading="skeletonLoading" />
              </el-col>
              <el-col :span="14">
                <div class="codeInfo">
                  <div>
                    <p class="codeTxt1">
                      <span class="fn16">X</span>&nbsp;
                      <span>{{ item.rewardMulti }}</span>
                    </p>
                    <p class="codeTxt">{{ $t("Datalang.newly_highest") }}</p>
                  </div>
                  <div>
                    <p class="codeTxt2">
                      <span>{{ divideAccuracy(Number(item.rewardAmount), useraccuracy) }}</span
                      >&nbsp;
                      <span class="c900">{{ userCoinCode }}</span>
                    </p>
                    <p class="codeTxt">{{ $t("Datalang.newly_winning") }}</p>
                  </div>
                  <div>
                    <p class="codeTxt3">{{ item.betCn }}</p>
                    <p class="codeTxt">{{ $t("Datalang.newly_betcount") }}</p>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="codeRank" :class="'type' + index">{{ index < 3 ? "" : index + 1 }}</div>
          </div>
        </template>
      </GameSlide>

      <div class="p-hot-box" v-else :class="[`content_${content_index}`, 'multi-row']">
        <template v-for="(item, i) in list">
          <div
            class="img-box"
            v-if="hidegd(item)"
            :key="'pc_' + i"
            :class="{ 'mr-0': (i + 1) % colNum === 0 }"
            :style="{ width: `${gameThumbWidth}%`, marginRight: '2%' }"
          >
            <gameItem @play="reportClick" :key="'game_' + i" :item="item" :skeletonLoading="skeletonLoading" />
          </div>
        </template>
        <div v-if="showType === 3 && isMore" class="more-btn-box">
          <div class="more-btn" @click="moreFun">{{ $t("Datalang.HomePage_BTM_loadmore") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mode4 from "@/lobby_common/mixins_views/homeModule/mode13.js";
import GameSlide from "./GameSlide.vue";
export default {
  mixins: [mode4],
  components: {
    GameSlide,
  },
  props: ["gameShowType"],
  data() {
    return {
      canPrev: false,
      canNext: true,
    };
  },
  computed: {
    // h5List() {
    //   if (this.gameShowType === 0) {
    //     let row = this.item.game_show_type;
    //     row = row || 2;
    //     const max = row * 3;
    //     if (this.list.length > max) {
    //       return this.list.slice(0, max);
    //     }
    //     return this.list;
    //   }
    //   return this.list;
    // },
  },
  methods: {
    onCanPrevChange(value) {
      console.log("onCanPrevChange=>", value);
      this.canPrev = value;
    },
    onCanNextChange(value) {
      this.canNext = value;
      console.log("onCanNextChange=>", value);
    },
  },
};
</script>
<style lang="scss" scoped>
.mode4-header {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  .title-icon {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }
  .title {
    font-size: 15px;
    margin-left: 10px;
    font-weight: bold;
    color: var(--font-color-1601);
  }

  .mode-all {
    box-sizing: border-box;
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
    cursor: pointer;
    color: var(--font-color-200);
    background: var(--button-1200);
    box-shadow: var(--boxShadow-1200);
    border-radius: var(--radius-200);
    font-size: 13px;
  }

  .mode-all:hover {
    background: var(--button-1201);
  }
}

.mode4-box {
  margin-top: 10px;
  // background: var(--background-900);
}

.content {
  position: relative;
  display: flex;
  // background: #f4f5f9 !important;
  line-height: 0;
}

.el-icon-arrow-left.custom {
  width: 30px;
  position: absolute;
  right: 48px;
  cursor: pointer;
  z-index: 1;
  border-radius: 5px;
  -webkit-border-radius: 5px;
}

.el-icon-arrow-right.custom {
  width: 30px;
  position: absolute;
  right: 12px;
  cursor: pointer;
  z-index: 1;
  border-radius: 5px;
  -webkit-border-radius: 5px;
}

.hot-content {
  overflow: hidden;
  @media (max-width: 768px) {
    touch-action: pan-y pinch-zoom;
  }
  .slideList {
    margin-top: 10px;
  }
}
.luckyMoudle {
  // background: var(--background-1200);
  border-radius: var(--radius-300);
  padding: 10px 10px 0px 0;
  background-position: top 0px right 0px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  box-sizing: border-box;
  width: 100%;
  @media (max-width: 768px) {
    border-radius: var(--radius-301);
  }
  &:nth-child(1) {
    background-image: url("~@/lobby_common/assets/homePage/bg1.png");
  }
  &:nth-child(2) {
    background-image: url("~@/lobby_common/assets/homePage/bg2.png");
  }
  &:nth-child(3) {
    background-image: url("~@/lobby_common/assets/homePage/bg3.png");
  }
  .codeInfo {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 34vw;
    max-height: 180px;
    margin: 0px 0;
    text-align: left;
    p {
      margin: 0;
      padding: 0;
      width: 100%;
      overflow: hidden; /* 确保超出容器的文本被裁剪 */
      white-space: nowrap; /* 确保文本在一行内显示 */
      text-overflow: ellipsis;
    }
    .codeTxt {
      padding-top: 4px;
      color: var(--font-color-900);
      font-size: 12px;
    }
    .codeTxt1 {
      font-size: 14px;
      color: var(--font-color-1000);
      font-weight: bold;
      .fn16 {
        font-size: 12px;
      }
    }
    .codeTxt2 {
      font-size: 12px;
      color: var(--font-color-200);
      .c900 {
        color: var(--font-color-900);
      }
    }
    .codeTxt3 {
      font-size: 12px;
      color: var(--font-color-200);
    }
  }
  .codeRank {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 27px;
    height: 30px;
    position: absolute;
    top: 5px;
    right: 5px;
    color: var(--font-color-1100);
    background-image: url("~@/lobby_common/assets/homePage/rank4.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    font-size: 16px;
    &.type0 {
      background-image: url("~@/lobby_common/assets/homePage/rank1.png");
    }
    &.type1 {
      background-image: url("~@/lobby_common/assets/homePage/rank2.png");
    }
    &.type2 {
      background-image: url("~@/lobby_common/assets/homePage/rank3.png");
    }
  }
}
.p-hot-box {
  position: relative;
  // display: flex;
  padding: 0 12px;

  &.multi-row {
    padding-bottom: 10px;
    flex-wrap: wrap;
  }

  &.one-row {
    display: flex;
  }
  .img-box {
    position: relative;
    display: inline-block;
    width: 30%;
    padding-top: 24px;
    margin-right: 4%;
    cursor: pointer;
    transition: 0.5s;
    flex-shrink: 0;
    @media (max-width: 768px) {
      padding-top: 12px;
    }
    &:last-child {
      margin-right: 0;
    }
    &.mr-0 {
      margin-right: 0 !important;
    }

    .txt {
      text-align: center;
      height: 36px;
      line-height: 36px;
    }

    .tubiao {
      position: absolute;
      right: 0px;
      width: 40px;
      height: 35px;
      top: 0px;
      box-sizing: border-box;
      z-index: 999;
    }
  }
}

.more-btn-box {
  width: 100%;
  padding: 10px 0;
  text-align: center;
  .more-btn {
    // width: 80px;
    display: inline-block;
    padding: 0 15px;
    height: 28px;
    line-height: 28px;
    color: var(--font-color-600);
    background: var(--background-1000);
    margin: 0 auto;
    border-radius: 5px;
    text-align: center;
    font-size: 12px;
    cursor: pointer;
  }
}
</style>
